import { Button, Card, Col, Collapse, DatePicker, Empty, Form, message, Row, Skeleton, Spin, Table } from "antd";
import React, { Component } from "react";
import moment from "moment";
import { CSVLink } from "react-csv";
import { uniqBy } from "lodash";
import FieldSearchForm from "../../components/FieldSearchForm";
import "./style.css";
import { sanitizeFieldName } from "../../util/methods";

const { Panel } = Collapse;

const getTotalHour = performanceData => {
  const totalHr = performanceData.maintenance.reduce((accumulator, item) => {
    return accumulator + Number(item.hour);
  }, 0);
  return totalHr / 60;
};

const getShortOrExcess = (minHr, totalHr) => {
  return (totalHr - minHr).toFixed(1); //totalHr > minHr ? "Excess" : totalHr < minHr ? "Short" : "-";
};

const cols = [
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    render: (_, row) => (row.type && row.type.name ? row.type.name : "-")
  },
  {
    title: "Activity No",
    dataIndex: "jobCardActivityNumber",
    key: "jobCardActivityNumber",
    render: (data) => {
      return data && data.activitySerialNo ? data.activitySerialNo : '--';
    }
  },
  {
    title: "Activity Status",
    dataIndex: "activityStatus",
    key: "activityStatus"
  },
  {
    title: "Work",
    dataIndex: "workDetails",
    key: "workDetails"
  },
  {
    title: "Time From",
    dataIndex: "timeFrom",
    key: "timeFrom",
    render: (_, row) => moment(row.timeFrom).format("h:mm a")
  },
  {
    title: "Time To",
    dataIndex: "timeTo",
    key: "timeTo",
    render: (_, row) => moment(row.timeTo).format("h:mm a")
  },
  {
    title: "Hour",
    dataIndex: "hour",
    key: "hour",
    render: (_, row) => (row.hour / 60).toFixed(1)
    // render: (_, row) =>
    //   row.hour
    //     ? moment
    //         .utc()
    //         .startOf("day")
    //         .add({ minutes: row.hour })
    //         .format("H:mm")
    //     : 0
  }
];

class Report extends Component {
  componentDidMount() { }

  handleClear = () => {
    this.props.clearReportData();
  };

  handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      // if (err) {
      //   return console.log(err);
      // }
      if (moment(values.periodFrom).isSameOrBefore(values.periodTo)) {
        const _values = Object.assign(values);
        _values.periodFrom = moment(values.periodFrom).toISOString();
        _values.periodTo = moment(values.periodTo).toISOString();
        this.props.generateReport(_values);
      } else {
        message.error("Period From couldn't come earlier than Period To!");
      }
    });
  };

  downloadCSV = datas => {
    let rowData = [];
    datas.map(item => {
      const maintenanceDatas =
        item.maintenance && item.maintenance.length > 0
          ? item.maintenance.map(newItem => {
            return {
              Date: moment(item.date).format("DD-MM-YYYY"),
              Type: newItem.type.name,
              "Activity Number": newItem.jobCardActivityNumber,
              "Activity Status": newItem.activityStatus,
              "Work Details": newItem.workDetails,
              "Time From": moment(newItem.timeFrom).format("h:mm a"),
              "Time To": moment(newItem.timeTo).format("h:mm a"),
              Hours: (Number(newItem.hour) / 60).toFixed(1)
            };
          })
          : [];
      rowData = [...rowData, ...maintenanceDatas];
    });
    return (
      <CSVLink filename={"performance_report.csv"} data={rowData}>
        <Button type="primary" icon="download">
          Excel
        </Button>
      </CSVLink>
    );
  };

  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    const { loading, title, resource, reportData } = this.props;

    let totalAllHr = 0;
    let totalMinHr = 0;

    let performanceData = [];
    if (reportData && reportData.length > 0) performanceData = [...reportData];

    const days = uniqBy(performanceData, item =>
      moment(item.date).format("DD-MM-YYYY")
    ).length; //performanceData.length;

    const dataRows = performanceData
      ? performanceData.map((item, index) => {
        const minHr = item.employee.minimumWorkHours;
        const totalHr =
          item.maintenance && item.maintenance.length > 0
            ? getTotalHour(item)
            : 0;
        totalAllHr += totalHr;
        totalMinHr += minHr;
        return (
          <Panel
            key={index}
            header={
              <Row className="mp-card-row">
                <Col xs={24} sm={12} md={8} lg={5}>
                  <div className="mp-card-details content-row-style">
                    <div>{moment(item.date).format("DD-MM-YYYY")}</div>
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={5}>
                  <div className="mp-card-details content-row-style">
                    <div>{totalHr.toFixed(1)}</div>
                  </div>
                </Col>

                <Col xs={24} sm={12} md={8} lg={5}>
                  <div className="mp-card-details content-row-style">
                    <div>{minHr.toFixed(1)}</div>
                  </div>
                </Col>

                <Col xs={24} sm={12} md={12} lg={5}>
                  <div className="mp-card-details content-row-style">
                    <div>{getShortOrExcess(minHr, totalHr)}</div>
                  </div>
                </Col>

                {
                  <Col xs={24} sm={12} md={12} lg={4}>
                    <div className="mp-card-details content-row-style">
                      {
                        <Button
                          type="link"
                          size="small"
                          style={{ marginBottom: 0 }}
                          onClick={event => {
                            event.stopPropagation();
                            this.props.history.push(
                              `/manpower-performance/edit/${item._id}`
                            );
                          }}
                        >
                          Voucher
                        </Button>
                      }
                    </div>
                  </Col>
                }
              </Row>
            }
          // extra={this.PanelButtonHandler(item._id)}
          >
            {item.maintenance && item.maintenance.length > 0 ? (
              <Table
                dataSource={item.maintenance}
                columns={cols}
                loading={loading}
                rowKey={record => record.timeFrom + record.timeTo}
              />
            ) : null}
          </Panel>
        );
      })
      : null;

    const rowTitle = performanceData ? (
      <div>
        <Row className="mp-card-header">
          <Col xs={24} sm={12} md={8} lg={5}>
            <div className="mp-card-details content-row-style">
              <div>DATE</div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={5}>
            <div className="mp-card-details content-row-style">
              <div>TOTAL HOUR</div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={5}>
            <div className="mp-card-details content-row-style">
              <div>MINIMUM HOUR</div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={12} lg={5}>
            <div className="mp-card-details content-row-style">
              <div>SHORT/EXCESS</div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={12} lg={2}>
            <div className="mp-card-details content-row-style">
              <div></div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={12} lg={2}>
            <div className="mp-card-details content-row-style">
              <div style={{ marginBottom: 0 }}>
                {this.downloadCSV(performanceData)}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    ) : null;

    const footerPanel = (totalMin, totalFull, days) =>
      performanceData ? (
        <div>
          <Row className="mp-card-header">
            <Col xs={24} sm={12} md={8} lg={5}>
              <div className="mp-card-details content-row-style">
                <div>{days} Days</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={8} lg={5}>
              <div className="mp-card-details content-row-style">
                <div>{totalFull.toFixed(1)}</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={8} lg={5}>
              <div className="mp-card-details content-row-style">
                <div>{totalMin.toFixed(1)}</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={5}>
              <div className="mp-card-details content-row-style">
                <div>{getShortOrExcess(totalMin, totalFull)}</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={2}>
              <div className="mp-card-details content-row-style">
                <div></div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={2}>
              <div className="mp-card-details content-row-style">
                <div></div>
              </div>
            </Col>
          </Row>
        </div>
      ) : null;

    return (
      <div>
        <Spin spinning={loading}>
          <Card
            className={`gx-card-metrics`}
            title={`${sanitizeFieldName(resource)} ${title}`}
          >
            <Form
              onSubmit={this.handleSubmit}
              className="ant-advanced-search-form"
              layout="inline"
              labelAlign="left"
            >
              <Row gutter={8}>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <Form.Item
                    key={"periodFrom"}
                    label={"Select Period From"}
                    style={{ width: "100%" }}
                  >
                    {getFieldDecorator(`periodFrom`, {
                      rules: [
                        { required: true, message: `Period From is required!` }
                      ],
                      initialValue: null
                    })(<DatePicker style={{ width: "100%" }} />)}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <Form.Item
                    key={"periodTo"}
                    label={"Select Period To"}
                    style={{ width: "100%" }}
                  >
                    {getFieldDecorator(`periodTo`, {
                      rules: [
                        { required: true, message: `Period To is required!` }
                      ],
                      initialValue: null
                    })(<DatePicker style={{ width: "100%" }} />)}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <FieldSearchForm
                    title={title}
                    key={"manpower"}
                    name={`manpower`}
                    label={"Select Manpower Name"}
                    message={`Manpower is required`}
                    required={true}
                    field={"name"}
                    model={"Manpower"}
                    getFieldDecorator={getFieldDecorator}
                    setFieldsValue={setFieldsValue}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <Form.Item key={"button"} style={{ width: "100%", top: 25 }}>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Generate Report
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
          <Card className={`gx-card-metrics`}>
            <div>
              {performanceData.length > 0 && dataRows ? (
                <>
                  {/* <Button type="primary" onClick={this.handleClear}>Clear</Button> */}
                  {rowTitle}
                  <Collapse bordered={false}>
                    {dataRows}
                    {footerPanel(totalMinHr, totalAllHr, days)}
                  </Collapse>
                </>
              ) : loading ? (
                <Skeleton active />
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
          </Card>
        </Spin>
      </div>
    );
  }
}

const CreateForm = Form.create({
  name: "global_state"
})(Report);
export default CreateForm;
